export default __webpack_public_path__ + "static/media/handbookCartEmptyImg.9c0969ce.png";